import MaskedInput from 'react-text-mask'

import { Intent } from '../../config/intent'
import { INPUT_CLASSES } from '../input/input'

export interface DOBInputProps {
    id: string
    onChange: (value: any) => void
    intent?: Intent
    value: string
    message?: string
}

const mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]

export function DOBInput({
    id,
    onChange,
    intent = Intent.DEFAULT,
    message,
    ...rest
}: DOBInputProps) {
    return (
        <>
            <MaskedInput
                keepCharPositions={true}
                guide={false}
                placeholder='MM/DD/YYYY'
                mask={mask}
                render={(ref, { onChange: onMaskChange, ...rest }) => {
                    const wrapperClasses = [
                        ...INPUT_CLASSES.wrapper,
                        `border-${intent}`,
                    ].join(' ')

                    return (
                        <div className={wrapperClasses}>
                            <input
                                name={id}
                                id={id}
                                type='text'
                                ref={ref}
                                onChange={e => {
                                    onMaskChange(e.target.value)
                                    onChange(e)
                                }}
                                className={INPUT_CLASSES.input.join(' ')}
                                intent={intent}
                                data-testid='dob-input'
                                {...rest}
                            />
                        </div>
                    )
                }}
                {...rest}
            />
            {message && <label className='text-danger'>{message}</label>}
        </>
    )
}
